//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as b from '@/static/blog.json'

let blog = b.default

import SocialShareMixinSet from '@/components/Blog/SocialShareMixinSet.vue'
import { blogMeta } from '@/data/meta'

const { DateTime } = require('luxon')
export default {
  mixins: [SocialShareMixinSet],
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let slug = to.params.slug
      vm.inicializarTexto(slug)
      vm.getBlogs(slug)
    })
  },
  beforeRouteUpdate(to, from, next) {
    let slug = to.params.slug
    this.inicializarTexto(slug)
    this.getBlogs(slug)
    next()
  },
  head() {
    if (this.artigometa && this.artigometa.titulo)
      return blogMeta(this.artigometa)
  },
  data() {
    return {
      DateTime,
      artigo: {},
      imageLoaded: false,
      blogs: [],
      loaded: false,
    }
  },
  async asyncData({ params }) {
    let slug = params.slug
    let artigometa = blog.find((a) => a.slug === slug)
    return { artigometa }
  },
  methods: {
    inicializarTexto(slug) {
      this.artigo = blog.find((a) => a.slug === slug)
      this.loaded = true
      if (this.artigo === undefined) this.$router.push('/404')
    },
    getBlogs(slug) {
      let sliced = screen.availWidth > 600 && screen.availWidth < 1200 ? 2 : 3
      this.blogs = blog.filter((a) => a.slug !== slug).slice(0, sliced)
    },
  },
  mounted() {
    addEventListener('resize', () =>
      this.getBlogs(location.pathname.split('/')[2])
    )
  },
}
